namespace TabAurous.Inventory {
    export interface SKURepricingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        VoucherNo?: string;
        UserId?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: SKURepricingDetailsRow[];
        Items?: SKURepricingItemsRow[];
        Pieces?: number;
        NoofSKU?: number;
        LineNoSelected?: number;
        ProductIdSelected?: number;
        AttributeIdSelected?: number;
        SKUSelected?: string;
        Markup?: number;
        GenerateSKU?: string;
        Username?: string;
        PostingDate?: string;
        IsPosted?: boolean;
    }

    export namespace SKURepricingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.SKURepricing';
        export const deletePermission = 'Inventory:SKURepricing:Delete';
        export const insertPermission = 'Inventory:SKURepricing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:SKURepricing:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            Items = "Items",
            Pieces = "Pieces",
            NoofSKU = "NoofSKU",
            LineNoSelected = "LineNoSelected",
            ProductIdSelected = "ProductIdSelected",
            AttributeIdSelected = "AttributeIdSelected",
            SKUSelected = "SKUSelected",
            Markup = "Markup",
            GenerateSKU = "GenerateSKU",
            Username = "Username",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted"
        }
    }
}
